import ApiService from '.';
import { AddTasksListItemParams, AddTasksListParams, AssignTaskListItemParams } from '../params/redux/task';

/**
 * @heading1: Task API service.
 * @paragraph: This module provides a set of methods to interact with the Task API.
 * It handles operations like Fetching tasks, add task, edit task etc.
 */

const TaskApi = {
    fetchTasks: (token: string) => {
        // Perform a GET request to fetch tasks
        return ApiService.apiHit({
            url: 'get-board-details',
            method: 'get',
            token
        });
    },
    fetchClientTask: (token: string, client_id: number) => {
        // Perform a Post request to fetch client task endpoint with the token
        return ApiService.apiHit({
            url: 'get-board-details',
            method: 'post',
            token,
            data: {
                client_id
            },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    createTaskList: (token: string, data: AddTasksListParams) => {
        // Perform a Post request to create task list endpoint with the token
        return ApiService.apiHit({
            url: 'create-board-list',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    createTaskListItem: (token: string, data: AddTasksListItemParams) => {
        // Perform a Post request to create task list item endpoint with the token
        return ApiService.apiHit({
            url: 'create-board-list-item',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    dragTaskListItem: (token: string, item_id: number, list_id: number) => {
        // Perform a Post request to drag task list item endpoint with the token
        return ApiService.apiHit({
            url: 'drag-board-list-item',
            method: 'post',
            token,
            data: {
                item_id,
                list_id
            },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    createTaskListItemComment: (token: string, item_id: number, comment: string) => {
        // Perform a Post request to create task list item's comment endpoint with the token
        return ApiService.apiHit({
            url: 'add-board-list-item-comment',
            method: 'post',
            token,
            data: {
                item_id,
                comment
            },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    addTaskListItemfile: (token: string, item_id: number, file: string, filename: string) => {
        // Perform a Post request to add task list item's file endpoint with the token
        return ApiService.apiHit({
            url: 'add-board-list-item-file',
            method: 'post',
            token,
            data: {
                item_id,
                file,
                filename
            },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchSingleTaskItemDetails: (token: string, item_id: number) => {
        // Perform a Get request to fetch single task item details endpoint with the token
        return ApiService.apiHit({
            url: 'get-single-list-item',
            method: 'post',
            token,
            data: { item_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    deleteTaskItem: (token: string, item_id: number) => {
        // Perform a Post request to delete task item endpoint with the token
        return ApiService.apiHit({
            url: 'delete-list-item',
            method: 'post',
            token,
            data: { item_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    markTaskItemComplete: (token: string, item_id: number, complete_status: 0 | 1) => {
        // Perform a Post request to mark task item complete endpoint with the token
        return ApiService.apiHit({
            url: 'list-item-mark-complete-incomplete',
            method: 'post',
            token,
            data: { item_id, complete_status },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    editTaskListItem: (token: string, data: AddTasksListItemParams) => {
        // Perform a Post request to edit task item details endpoint with the token
        return ApiService.apiHit({
            url: 'edit-board-list-item',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchDueTaskList: (token: string, client_id: number) => {
        // Perform a Post request to fetch due task list endpoint with the token
        return ApiService.apiHit({
            url: 'get-due-tasks',
            method: 'post',
            token,
            data: { client_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    assignTaskListItem: (token: string, data: AssignTaskListItemParams) => {
        // Perform a Post request to fetch due task list endpoint with the token
        return ApiService.apiHit({
            url: 'assign-list-item',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchAssignedListItems: (token: string) => {
        // Perform a Post request to fetch due task list endpoint with the token
        return ApiService.apiHit({
            url: 'get-assigned-list-item',
            method: 'post',
            token,
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    removeAssignedListItem: (token: string, data: AssignTaskListItemParams) => {
        // Perform a Post request to fetch due task list endpoint with the token
        return ApiService.apiHit({
            url: 'remove-assign-list-item',
            method: 'post',
            token,
            data,
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    editBoardList: (token: string, list_id: number, title: string, client_id: number) => {
        // Perform a Post request to fetch due task list endpoint with the token
        return ApiService.apiHit({
            url: 'edit-board-list',
            method: 'post',
            token,
            data: { list_id, title, client_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    deleteBoardList: (token: string, list_id: number, client_id: number) => {
        // Perform a Post request to fetch due task list endpoint with the token
        return ApiService.apiHit({
            url: 'delete-board-list',
            method: 'post',
            token,
            data: { list_id, client_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchAllUrgentDueTask: (token: string) => {
        // Perform a Post request to fetch due task list endpoint with the token
        return ApiService.apiHit({
            url: 'get-urgent-due-task',
            method: 'post',
            token,
            data: {},
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    },
    fetchClientBoardDetails: (token: string, client_id: number) => {
        // Perform a Post request to fetch due task list endpoint with the token
        return ApiService.apiHit({
            url: 'get-board-details-client',
            method: 'post',
            token,
            data: { client_id },
            getIp: {
                get: true,
                fieldValue: 'user_ip'
            }
        });
    }
};

export default TaskApi;
